export const UPDATE_ACTIONS = {
  TOGGLE_TEXT_VISIBILITY: "toggleTextVisibility",
  TOGGLE_ROW_DENSITY: "toggleRowDensity",
} as const;
